const submitButtonOptions = {
  wrapperCol: { span: 24 },
  buttonList: [
    {
      title: '登录',
      block: true,
      col: 18,
      type: 'primary',
      cb: 'submit'
    }
  ]
}
const regFormOptions = {
  wrapperCol: { span: 16 },
  labelCol: { span: 5 },
  layout: 'horizontal',
  formConfig: []
}

const loginFormOptions = {
  wrapperCol: { },
  labelCol: {},
  layout: 'horizontal',
  formConfig: []
}

const FORM_CONFIG_LOGIN = {
  initModel: {
    email: '',
    password: '',
    code: '',
    uuid: ''
  }, // 默认值
  tempModel: {}, // 保存值
  formRootInstance: {
    // 整体表单配置
    ...loginFormOptions,
    baseFormConfig: [
      {
        type: 'input',
        placeholder: '请输入账号',
        prop: 'email',
        allowClear: true,
        sloteOptions: [
          {
            type: 'icon',
            sloteType: 'user',
            position: 'prefix',
            key: '1'
          }
        ]
      },
      {
        type: 'password',
        placeholder: '请输入密码',
        prop: 'password',
        allowClear: true,
        sloteOptions: [
          {
            type: 'icon',
            sloteType: 'lock',
            position: 'prefix',
            key: '1'
          }
        ]
      },
      {
        type: 'input',
        placeholder: '输入验证码',
        prop: 'code',
        allowClear: true,
        isAuthCode: true
        // sloteOptions: [ //   { //     type: 'icon', sloteType: 'safety-certificate', position: 'prefix', key: '1' //   } // ]
      }
    ]
  },
  rules: {
    email: [
      { required: true, message: '账号不能为空', trigger: ['blur'] }
      // { required: true, message: '账号填写格式有误', max: 80, pattern: '+A[a-ZA-Z0-9_]+@[a-ZA-Z0-9_-]+(.[a-ZA-Z0-9_-]+)+$', trigger: ['blur'], },
    ],
    password: [
      { required: true, message: '密码不能为空', trigger: ['blur'] }
      // { required: true, message: '密码长度必须在6-16之间', min: 6, max: 16, trigger: ['blur'], },
      // { required: true, message: '密码格式有误,含有非法字符[ ;|<>``&!*(~^)#?:"/$=\\"+]', pattern: '[a-z、A-Z、0-9 ]', trigger: ['blur'], },
    ],
    code: [{ required: true, message: '验证码不能为空', trigger: ['blur'] }]
  },
  submitButtonOptions
}
var reg = new RegExp(
  '^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$'
) // 校验手机号

const FORM_CONFIG_REGISTER = {
  // 注册
  initModel: {}, // 默认值
  tempModel: {}, // 保存值
  formRootInstance: {
    // 整体表单配置
    ...regFormOptions,
    baseFormConfig: [
      {
        type: 'input',
        placeholder: '账号',
        prop: 'username',
        allowClear: true,
        label: '账号'
      },
      // {
      //   type: 'input',
      //   placeholder: '手机号码',
      //   prop: 'phonenumber',
      //   allowClear: true,
      //   label: '手机号码'
      // },
      // {
      //   type: 'input',
      //   placeholder: '机构',
      //   prop: 'enpName',
      //   allowClear: true,
      //   label: '机构'
      // },
      {
        type: 'password',
        placeholder: '6-16位密码，区分大小写',
        prop: 'password',
        allowClear: true,
        label: '密码'
      },
      {
        type: 'password',
        placeholder: '确认密码',
        prop: 'affirmPassword',
        allowClear: true,
        label: '确认密码'
      },
      {
        type: 'input',
        placeholder: '输入验证码',
        prop: 'code',
        allowClear: true,
        isAuthCode: true,
        label: '验证码'
      },
      {
        type: 'input',
        placeholder: '邮箱',
        prop: 'email',
        allowClear: true,
        label: '邮箱'
      }
    ]
  },

  rules: {
    username: [
      { required: true, message: '用户名不能为空', trigger: ['blur'] },
      {
        validator: (rule, val, callback) => {
          if (!/^[a-zA-Z0-9]+$/.test(val)) {
            callback(new Error('用户名只能包含字母和数字!'))
          } else {
            callback()
          }
        }
      }
    ],
    email: [
      { type: 'email', message: '请输入正确的邮箱!' },
      { required: true, message: '账号不能为空', trigger: ['blur'] }
      // { required: true, message: '账号填写格式有误', max: 80, pattern: '+A[a-ZA-Z0-9_]+@[a-ZA-Z0-9_-]+(.[a-ZA-Z0-9_-]+)+$', trigger: ['blur'], },
    ],
    phonenumber: [
      // { required: true, message: '手机号码不能为空', trigger: ['blur'] },
      // {
      //   validator: (rule, val, callback) => {
      //     if (!reg.test(val)) {
      //       callback(new Error('请输入正确的手机号!'))
      //     } else {
      //       callback()
      //     }
      //   }
      // }
    ],
    enpName: [
      { required: true, message: '企业名称不能为空', trigger: ['blur'] }
    ],
    affirmPassword: [
      { required: true, message: '确认密码不能为空', trigger: ['blur'] },
      {
        validator: (rule, value, callback) => {
          console.log(rule)
          if (value === '') {
            callback(new Error('请再次输入新密码'))
          } else {
            callback()
          }
        }
      }
      // { required: true, message: '密码长度必须在6-16之间', min: 6, max: 16, trigger: ['blur'], },
      // { required: true, message: '密码格式有误,含有非法字符[ ;|<>``&!*(~^)#?:"/$=\\"+]', pattern: '[a-z、A-Z、0-9 ]', trigger: ['blur'], },
    ],
    password: [
      { required: true, message: '密码不能为空', trigger: ['blur'] },
      {
        pattern: /(?=.*([a-zA-Z].*))(?=.*[0-9].*)[a-zA-Z0-9-*/+.~!@#$%^&*()]{6,20}$/,
        message: '请输入6-20位含有字母、数字或符号！'
      }

      // { required: true, message: '密码长度必须在6-16之间', min: 6, max: 16, trigger: ['blur'], },
      // { required: true, message: '密码格式有误,含有非法字符[ ;|<>``&!*(~^)#?:"/$=\\"+]', pattern: '[a-z、A-Z、0-9 ]', trigger: ['blur'], },
    ],
    code: [{ required: true, message: '验证码不能为空', trigger: ['blur'] }]
  },
  submitButtonOptions: {
    ...submitButtonOptions,
    buttonList: [
      {
        title: '注册',
        block: true,
        col: 18,
        type: 'primary',
        cb: 'submit'
      }
    ]
  }
}

const FORM_CONFIG_FORGET = {
  // 注册
  initModel: {}, // 默认值
  tempModel: {}, // 保存值
  formRootInstance: {
    // 整体表单配置
    ...loginFormOptions,
    baseFormConfig: [
      {
        type: 'input',
        placeholder: '邮箱',
        prop: 'email',
        allowClear: true
      },
      // {
      //   type: 'input',
      //   placeholder: '手机号码',
      //   prop: 'phonenumber',
      //   allowClear: true
      // },
      {
        type: 'input',
        placeholder: '输入验证码',
        prop: 'code',
        allowClear: true,
        isAuthCode: true
      }
    ]
  },
  rules: {
    email: [{ required: true, message: '账号不能为空', trigger: ['blur'] }],
    // phonenumber: [
    //   { required: true, message: '手机号码不能为空', trigger: ['blur'] },
    //   {
    //     validator: (rule, val, callback) => {
    //       if (!reg.test(val)) {
    //         callback(new Error('请输入正确的手机号!'))
    //       } else {
    //         callback()
    //       }
    //     }
    //   }
    // ],
    code: [{ required: true, message: '验证码不能为空', trigger: ['blur'] }]
  },
  submitButtonOptions: {
    ...submitButtonOptions,
    buttonList: [
      {
        title: '找回密码',
        block: true,
        col: 18,
        type: 'primary',
        cb: 'submit'
      }
    ]
  }
}

module.exports = {
  FORM_CONFIG_LOGIN,
  FORM_CONFIG_REGISTER,
  FORM_CONFIG_FORGET
}
